import TestIds from 'constants/test-ids'
import { MbcDetail, MbcAssessment } from 'types/Visit/MeasurementBasedCare'

export type AssessmentDetailsProps = {
  assessment: MbcAssessment
}

export const patientAnswer = ['Not at all', 'Several days', 'More than half the days', 'Nearly every day']

const AssessmentDetails = ({ assessment }: AssessmentDetailsProps) => {
  const details = assessment.form.answers

  return (
    <div data-testid={TestIds.visits.measurementBasedCare.mbcColumn.modals.view}>
      <hr className="m-0" />
      <ol className="selection:pl-3 py-3 flex flex-col gap-2">
        {details.map((detail: MbcDetail, i) => {
          return (
            <li key={detail.field.title}>
              <h6 className="typography-h6">{`${i + 1}. ${detail.field.title}:`}</h6>
              <div className="flex justify-between">
                <p>{`A: ${patientAnswer[Number(detail.value)]}`}</p>
                <p>{`Points: ${detail.value}`}</p>
              </div>
            </li>
          )
        })}
      </ol>
      <hr className="m-0" />
      <div className="flex justify-end mt-3">
        <p className="font-semibold">{`Total Points: ${assessment.score}`}</p>
      </div>
    </div>
  )
}

export default AssessmentDetails
